const Footer = ({ children }) => {
  return <>{children}</>;
};

Footer.displayName = "PageFooter";

export default Footer;
